
function concierge() {

    var datavals = 'https://admin.resistanceibiza.com/api/v1/all?token=a1fd55fc91966c363621cc235a90221d';
  //var datavals = 'https://ultra.partners/test.json';
  var dateso = '', locationso = '', chaserso = '', drinkso = '';
  var Champagne = '';
  var Vodka = '';
  var Whisky = '';
  var Tequila = '';
  var Champagne = '';
  var Gin = '';
  var Rum = '';
  var Liquors = '';
  var Champagne = '';
  var Liquors = '';
  var Wine = '';
  var Chaser = '';


  if(window.location.hash) {

      var active = window.location.hash.slice(5);
      $(`#date option:eq(${active})`).prop('selected', true);

  }
/*
  $.get( datavals , function() {})
    .done(function(data) {

      $.each( data, function( key, val ) {

          if(key == 'dates') {
            $.each( val, function( keyname, value ) {
              dateso += '<option value="'+value.id+'">'+value.label+'</option>';
            });
          }

          if(key == 'drinks') {
              $.each( val, function( keyname, value ) {

                  if(value.type == 'Champagne') {
                    Champagne += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Vodka') {
                    Vodka += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Whisky') {
                    Whisky += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Tequila') {
                    Tequila += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Gin') {
                    Gin += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Rum') {
                    Rum += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Liquors') {
                    Liquors += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Wine') {
                    Wine += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  if(value.type == 'Chaser') {
                    Chaser += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
                  }
                  //drinkso += '<input type="checkbox" id="drinkid'+value.id+'"name="drinks[][drink_id]" value="'+value.id+'"><label class="" for="drinkid'+value.id+'"><span></span>'+value.name+'<ins><i>'+value.name+'</i></ins></label>';
              });
          }

      });

/*
      $('#champagne').append(Champagne);
      $('#vodka').append(Vodka);
      $('#whisky').append(Whisky);
      $('#tequila').append(Tequila);
      $('#gin').append(Gin);
      $('#rum').append(Rum);
      $('#liquors').append(Liquors);
      $('#wine').append(Wine);
      $('#chasers').append(Chaser);

      $('#event_date').append(dateso);

      $('#concierge-form').fadeIn(300);

  });
  */

  var cform = $('#concierge-form');

  if ( pplang == 'es') {
      $.validator.messages.required = 'CAMPO REQUERIDO';
  }


  cform.on('submit', function(e) {
      e.preventDefault();


  }).validate({
      rules: {
          "hiddenRecaptcha": {
              required: function() {
                  if(grecaptcha.getResponse() == '') {
            //log('yes recaptcha');
            return true;
        } else {
            //log('no recaptcha');
            return false;
        }
    }
}
},
messages: {
    email: 'Please enter a valid email',
    concierge_email:'Please enter a valid email',
},
submitHandler: function() {
    if( $('#client_email').val() != $('#confirm_email').val()) {
        showResult(errors.matchemail, 'error');
        $('#client_email').addClass('error');
        $('#confirm_email').addClass('error');
        return;
    } else {
        $('#concierge-form li.submit>button')
        .attr('disabled', true)
        .addClass('working');
        conciergePost();
    }
}

});

}

function conciergePost() {

    var cform = $('#concierge-form');

    // Serialize the form data
    var dataString = cform.serialize();

    var token = $('#token').val();
    var path = $('#path').val();


    var smessage = 'thank you for your interest in booking a table for RESISTANCE Ibiza.<br>We have received your information and will get in touch with you soon.';
    var stitle = 'Success!';

    if(pplang == 'es') {
        stitle = 'Exito!';
        smessage = 'gracias por tu interÃ©s en reservar una mesa durante RESISTANCE Ibiza.<br>Hemos recibido tu informaciÃ³n y nos comunicaremos contigo muy pronto.';
    }


    var countrycode = $('div.selected-dial-code').text()+' ';
    countrycode = encodeURIComponent(countrycode);
    dataString = dataString.replace('&phone_number=', '&phone_number='+countrycode);

/*
    var xmlHttp = new XMLHttpRequest();
    // Add Listener
    xmlHttp.onreadystatechange = function() {
    if(xmlHttp.readyState == 4 && xmlHttp.status == 200)
    {
    log(xmlHttp.status,xmlHttp.responseText,xmlHttp);

    }
    }
    // run post
    xmlHttp.open("post", "https://admin.resistanceibiza.com/api/v1/concierge?token=a1fd55fc91966c363621cc235a90221d");
    xmlHttp.send(dataString);
    */

    $.ajax({
        type: 'POST',
        url: 'https://admin.resistanceibiza.com/api/v1/reservation?key=a1fd55fc91966c363621cc235a90221d',
        data: dataString,
        dataType: 'html text'
    }).done(function(data){

        $("#concierge-form .error-output").fadeOut(300);
        $("#concierge-form ol").fadeOut(300);
        $("#concierge>h1,#concierge>p,#concierge>.lbreak").fadeOut(300);

        var guestname = $('#first_name').val();

        if(!guestname) {
            guestname = $('#first_name').val();
        }


        setTimeout(function(){
            $("#concierge-form").append(`<div class="result text-center" style="display:none"><h2 class="re-title text-center">${stitle}</h2><div class="lbreak op50"></div><p style="font-size:16px;"><span class="guest-name">${guestname}</span>, ${smessage}</p></div>`);
            $("#concierge-form .result").fadeIn(300);
            $("#concierge-form ol").remove();
        }, 300);


        $('#concierge-form li.submit>button')
        .attr('disabled', false)
        .removeClass('working');


    }).fail(function(xhr, ajaxOptions, thrownError){
        var errortext = xhr.responseText;

        if( xhr.responseText == '{"error":"undefined method \`message\' for :event_date:Symbol"}' ) {
            errortext = "<u>Invalid Date Selected</u>";
        }

        if( xhr.responseText == '{"error":"undefined method \`message\' for :client_name:Symbol"}' ) {
            errortext = "<u>You must enter Your Name</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :arrival_time:Symbol"}' ) {
            errortext = "<u>You must select an Arrival Time</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :people:Symbol"}' ) {
            errortext = "<u>You must choose a Party Size</u>";
        }
        if( xhr.responseText == '{"error":"undefined method \`message\' for :client_email:Symbol"}' ) {
            errortext = "<u>You must enter Your Email</u>";
        }

        $("#concierge-form .error-output")
        .html('ERROR: '+errortext+'. Please try again. If you continue to experience issues, please email info@resistanceibiza.com')
        .fadeIn(300);

        log(xhr, ajaxOptions, thrownError);
        log(xhr.responseText);

        setTimeout(function(){
            $('#concierge-form li.submit>button')
            .attr('disabled', false)
            .removeClass('working');
        }, 300);

    });

}


function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}

function glitchAnim() {

    var lis = $('ul.rea>li');
    var toanim = getRandomInt('4',lis.length );

    var selected = $('ul.rea>li:nth-child(1)');

    $('ul.rea>li').each(function(index){
        var el = $(this);
        setTimeout(function(){
            el.find('span.glitch').addClass('glitchanim');
        }, 300+ (index*500));

        setTimeout(function(){
            el.find('span.glitch').removeClass('glitchanim');
        }, 5500+ (index*500));
    });



    setTimeout(function(){
        glitchAnim();
    }, 6500+ (lis.length*500));

}

function nextArtist() {


    if ( !! $('.schedule').length ) {

/*      var el = $('.slist a.active');

      log(el.text());

      var nextlink = '';

      if(el.parent().hasClass('lastartistm')) {
        log('yes last');
        nextlink = el.parent().parent().parent().next('div.vistastage').find('.slist li:first-child a');
      } else {
        nextlink = el.parent().next().find('a');
      }
      log(nextlink);
      nextlink.trigger('click');*/

  } else {
      var el = $('.realist a.active, .realist18 a.active');
      var nextlink = '';

      if(el.hasClass('lastartist')) {
          nextlink = el.parent().parent().next('ul').find('li:first-child');
      } else {
          nextlink = el.parent().next();
      }

      log(nextlink);
      if(nextlink.hasClass('clear')) {
          nextlink = nextlink.next();
          log('yes');
      } else {
          log('no');
      }
      nextlink.find('a').trigger('click');
  }

}

function prevArtist() {


    if ( !! $('.schedule').length ) {
/*
      var el = $('.slist a.active');
      var prevlink = '';


      if(el.hasClass('firstartist')) {
        prevlink = el.parent().parent().prev('ul').find('li:last-child');
      } else {
        prevlink = el.parent().prev();
      }
      prevlink.find('a').trigger('click');*/
  } else {
      var el = $('.realist a.active, .realist18 a.active');

      var prevlink = '';

      if(el.hasClass('firstartist')) {
          prevlink = el.parent().parent().prev('ul').find('li:last-child');
      } else {
          prevlink = el.parent().prev();
      }


      if(prevlink.hasClass('clear')) {
          prevlink = prevlink.prev();
          log('yes');
      } else {
          log('no');
      }


      prevlink.find('a').trigger('click');
  }

}





function kbHandler() {

  // Bind Keyboard: left top right down = 37 38 39 40
  $(document).on("keyup", function (event) {

    // IF ANY ARROW KEY
    if (event.keyCode >= 37 && event.keyCode <= 40) {

        event.preventDefault();

      // IF RIGHT OR DOWN
      if ( event.keyCode > 38) {

          nextArtist();

      } else {

          prevArtist();
      }

  }


    // IF spacebar zoom in
    if (event.keyCode == 32) {
        nextArtist();
    }

});

}

// Bind and unbind keys for form elements
function unbindKeys() {
    $(document).off("keyup");
    $(document).off("keydown");
}

$("input, textarea, select").on("focus", function () { unbindKeys(); });
$("input, textarea, select").on("blur", function () { kbHandler(); });


function resistance() {

    if ( !! $('#concierge').length ) {
        concierge();
    }

    if ( !! $('.realist18').length ) {
        $('.realist18 a')
            .on('mouseenter', function(){
                $(this).stop(true,true).addClass('titleGlitch2');
            })
            .on('mouseleave', function(){
                $(this).stop(true,true).removeClass('titleGlitch2');
            });
    }



    if ( !! $('.phase2').length || $('.realist18').length ) {


        $('.realist a')
            .on('mouseenter', function(){
                $(this).stop(true,true).addClass('titleGlitch2');
            })
            .on('mouseleave', function(){
                $(this).stop(true,true).removeClass('titleGlitch2');
            });

        $('.realist li:nth-child(1) a').addClass('firstartist');
        $('.realist li:last-child a').addClass('lastartist');

        $('.mainstage div.slist li:nth-child(1) ').addClass('firstartistm');
        $('.mainstage div.slist li:last-child ').addClass('lastartistm');
        $('.laststage div.slist li:nth-child(1) ').addClass('firstartistv');
        $('.laststage div.slist li:last-child ').addClass('lastartistv');

        $('div.slist li a')
            .on('mouseenter', function(){
                var el = $(this);
                el.addClass('titleGlitch');
            })
            .on('mouseleave', function(){
                var el = $(this);
                el.removeClass('titleGlitch');
            });

        $('.schedule .week-nav a').on('click', function(){
            var el = $(this);

            var selector = el.data('event');

          //$('.flyer').hide();
          $('.nextbtn').hide();


          if(selector == 'all') {
              $('.week-nav a').removeClass('active');
              el.addClass('active');
              $('div.event').fadeIn(300 , 'easeInOutExpo');
              return;
          }
          if( el.hasClass('all')) {

              $('.week-nav a').removeClass('active');
              $('.week-nav a').removeClass('all');
              //$('.realist').removeClass('all');
              window.location.hash = '#all';
          }

          if( el.hasClass('active')) {

              $('.week-nav a')
              .removeClass('active')
              .addClass('all');
              $('div.event').fadeIn(300 , 'easeInOutExpo');
              window.location.hash = '#all';

          } else {

              $('.week-nav a')
              .removeClass('active')
              el.addClass('active');
              $(`div.event:not(.${selector})`).hide();
              $(`div.event.${selector}`).fadeIn(300 , 'easeInOutExpo');
              //$('div.event.'+selector).find('.flyer').fadeIn(300 , 'easeInOutExpo');
              $(`div.event.${selector}`).find('.nextbtn').fadeIn(300 , 'easeInOutExpo');

              window.location.hash = selector;

          }

      });

        $('.nextweekbtn').on('click', function() {
            $('.week-nav a.active').parent().next().find('a').trigger('click');
            scrollToTop();
        });

        $('.lineup2 .week-nav a').on('click', function(){
            var el = $(this);

            var selector = el.data('event');

            if( el.hasClass('all')) {

                $('.week-nav a').removeClass('active');
                $('.week-nav a').removeClass('all');
                $('.realist li').removeClass('shown').removeClass('removed');
                $('.realist').removeClass('all').addClass('single');
              //$('.realist').removeClass('all');
          }

          if( el.hasClass('active')) {

              $('.week-nav a')
              .removeClass('active')
              .addClass('all');
              $('.realist li').fadeTo(300,1);
              $('.realist li').addClass('shown').removeClass('removed');
              $('.realist').addClass('all').removeClass('single');

          } else {

              $('.week-nav a.active').removeClass('active');
              $('.realist li.shown').removeClass('shown');
              $('.realist li.removed').removeClass('removed');
              el.addClass('active');
              //$('.realist li:not(.'+selector+')').fadeTo(300,.15);
              //$('.realist li.'+selector).fadeTo(300,1);
              $(`.realist li:not(.${selector})`).addClass('removed');
              $(`.realist li.${selector}`).addClass('shown');

          }

      });


        $('body').append(artistsmodal);

        kbHandler();


        if ( !! $('.schedule').length ) {
            $('.md-nav').remove();
        }

        $('.realist a, .realist18 a, .slist a').each(function(){

            var
            output = '',
            el = $(this),
            slug = el.data('slug'),
            title = el.data('title'),
            customvid = el.data('vid'),
            customthumb = el.data('img'),
            artistURL = 'https://artists.ultramusicfestival.com/artist/';

            artistURL = artistURL + slug + '/';

            //log(slug);

            $.get( artistURL, function() {})
            .done(function(data) {

                var artist = data[0],
                atitle = artist.title,
                ytvid = artist.videoid,
                beatvid = artist.beattvid,
                image = artist.image,
                audio = artist.audio,
                playlist = artist.playlist,
                vidurl = '',
                artisthtml = '',
                vidclass = '';



                if(!customthumb && !image) {
                    image = 'https://resistanceibiza.com/wp-content/uploads/2018/05/resistance-placeholder.jpg';
                }


                if(!customthumb && image) {
                    el.attr('data-thumb', image);
                }



                if(customthumb || image) {
                    el.find('span.thumb img').attr('src', el.attr('data-thumb'));
                }


                if(customvid) {
                    ytvid = customvid;
                }

                if(ytvid && !umfradio.length || beatvid && !umfradio.length) {

                    if(beatvid) {
                        beatvid = beatvid.replace("http:", "https:");
                        vidurl = beatvid+'.frame';
                    } else {
                        vidurl = 'https://www.youtube.com/embed/'+ytvid+'?autoplay=0&showinfo=0';
                    }

                }

                if (vidurl) {
                    el.attr('data-vidurl', vidurl);
                }

                output += '<ul class="social clearfix mb25">';
                if(artist.website) {  output += "<li><a href="+artist.website+" title='"+atitle+" Website' target='_blank'><span class='fas fa-globe'></span></a></li>"; }
                if(artist.facebook) {  output += "<li><a href='https://www.facebook.com/"+artist.facebook+"' title='Facebook' target='_blank'><span class='fab fa-square-facebook'></span></a></li>"; }
                if(artist.twitter) {  output += "<li><a href='https://www.twitter.com/"+artist.twitter+"' title='"+atitle+" Twitter' target='_blank'><span class='fab fa-x-twitter'></span></a></li>"; }
                if(artist.instagram) {  output += "<li><a href='https://instagram.com/"+artist.instagram+"' title='"+atitle+" Instagram' target='_blank'><span class='fab fa-instagram'></span></a></li>"; }
                if(artist.youtube) {  output += "<li><a href='https://www.youtube.com/"+artist.youtube+"' title='"+atitle+" YouTube' target='_blank'><span class='fab fa-youtube'></span></a></li>"; }
                if(artist.soundcloud) {  output += "<li><a href='https://soundcloud.com/"+artist.soundcloud+"' title='"+atitle+" Soundcloud' target='_blank'><span class='fab fa-soundcloud'></span></a></li>"; }
                output += "</ul>";

                el.attr('data-socials', output);

            });
        });


        $(document).on('click', '.md-next', function(){
            nextArtist();
        });
        $(document).on('click', '.md-prev', function(){
            prevArtist();
        });

        $(document).on('click', '.realist a, .realist18 a, .slist a', function(){
            var
            output = '',
            el = $(this),
            slug = el.data('slug'),
            title = el.data('title'),
            videourl = el.data('vidurl'),
            artistthumb = el.data('thumb'),
            eventlinks = el.data('eventlinks'),
            socials = el.data('socials'),
            eventlinkshtml = '',
            videocontent = '',
            thumbcontent = '',
            socialcontent = '',
            path = 'lineup',
            modal = $('#artistsmodal');

            if (pplang == 'es' || pplang == 'mx') {
                path = 'es/programa';
            }

            modalClose('#artistsmodal');
            modal.fadeIn(300);


            if(videourl) {
                videocontent = '<div class="video" style="width:400px; max-width:100%; margin:auto;"><div class="vid-wrap"> <iframe width="360" height="224" style="border:0" src="'+videourl+'" allowfullscreen=""></iframe> </div></div>';
            }

            if(artistthumb) {
                thumbcontent = '<div class="thumb glitchanim2" style="width:400px;  max-width:100%;  height:auto; margin:auto; margin-bottom:25px;"><img src="'+artistthumb+'" style="position:relative !important;"><img class="absolute" src="'+artistthumb+'"></div>';
            }

            if(socials) {
                socialcontent = '<div class="socials">'+socials+'</div>';
            }

            if(eventlinks) {
                var re = /\s*,\s*/;
                var eventlinks = eventlinks.split(re);

                eventlinks.forEach(function(word) {

                    var texttitle = '';
                    var texttitle = word.replace('week','Week ');
                    var texttitle = texttitle.replace('Week 1', 'WEEK 1 / 17.JUL');
                    var texttitle = texttitle.replace('Week 2', 'WEEK 2 / 24.JUL');
                    var texttitle = texttitle.replace('Week 3', 'WEEK 3 / 31.JUL');
                    var texttitle = texttitle.replace('Week 4', 'WEEK 4 / 7.AUG');
                    var texttitle = texttitle.replace('Week 5', 'WEEK 5 / 14.AUG');
                    var texttitle = texttitle.replace('Week 6', 'WEEK 6 / 21.AUG');
                    var texttitle = texttitle.replace('Week 7', 'WEEK 7 / 28.AUG');
                    var texttitle = texttitle.replace('Week 8', 'WEEK 8 / 4.SEP');
                    var texttitle = texttitle.replace('Week 9', 'WEEK 9 / 11.SEP');

                    if (pplang == 'es' || pplang == 'mx') {
                        texttitle = texttitle.replace('Week', 'Semana');
                    }
                    if(eventlinkshtml) {
                        eventlinkshtml += ' <a class="btn-main red-btn" href="'+ultra_settings.site_url+'/'+path+'#'+word+'">'+texttitle+'</a> ';
                    } else {
                        eventlinkshtml += ' <a class="btn-main red-btn" href="'+ultra_settings.site_url+'/'+path+'#'+word+'">'+texttitle+'</a> ';
                    }

                });
                var infocontent = '<div class="info">'+eventlinkshtml+' </div>'
            } else {
                var infocontent = '';
            }

            modal.find('.info').html(thumbcontent+'<h2>'+title+'</h2>'+socialcontent+infocontent+videocontent);


            $('.realist a.active, .realist18 a.active').removeClass('active');
            $('.slist a.active').removeClass('active');
            el.addClass('active');

        });


        setTimeout(function() {
        //$('.realist2 li:nth-child(2) a').trigger('click');
    }, 1000);



        if(window.location.hash) {

            var activetab = window.location.hash.slice(1);

            if(activetab != 'all') {
                $('a[data-event="' + activetab + '"]').trigger('click');
            }
        }

    }


    if ( !! $('#re-tickets').length ) {
        $('#re-tickets').find('.re-ticket').each(function(index){
            var el = $(this);
            setTimeout(function(){
                el.fadeTo(300,1)
            }, 500+ (index*100));
        });
    }

  // ibiza artists
  if ( !! $('ul.rea').length ) {
      glitchAnim();

      var lis = $('ul.rea>li');

      $('ul.rea>li')
          .on('mouseenter', function(){
              $(this).stop(true,true).find('span.glitch').removeClass('glitchanim');
          })
          .on('mouseleave', function(){
              $(this).stop(true,true).find('span.glitch').addClass('glitchanim');
          });

      lis.each(function(){

          var output = '';
          var adjust = '';
          var el = $(this);
          var link = el.find('a');
          var artistURL = 'https://artists.ultramusicfestival.com/artist/';
          var slug = el.data('slug');
          var customvid = el.data('vid');
          var customthumb = el.data('img');
          var artistURL = artistURL + slug + '/';


          $.get( artistURL, function() {})
          .done(function(data) {

              var artist = data[0],
              atitle = artist.title,

              ytvid = artist.videoid,
              beatvid = artist.beattvid,
              image = artist.image,
              audio = artist.audio,
              playlist = artist.playlist,
              vidurl = '',
              artisthtml = '',
              vidclass = '';

              if(customthumb == 'https://resistanceibiza.com/wp-content/uploads/2017/04/artist-holder.jpg' && image) {
                  el.find('img').attr('src',image);
              }

              if(customvid) {
                  ytvid = customvid;
              }

              if(ytvid && !umfradio.length || beatvid && !umfradio.length) {

                  if(beatvid) {
                      beatvid = beatvid.replace("http:", "https:");
                      vidurl = beatvid+'.frame';
                  } else {
                      vidurl = 'https://www.youtube.com/embed/'+ytvid+'?autoplay=1';
                  }

              }

              if (!vidurl) {
                    //log(vidurl);
                    el.find('.vidbtn').remove();
                    adjust = 'style="padding-top:0px;"';
                } else {
                    link.attr('href', vidurl);
                    link.attr('data-fancybox', 'images');
                }


                output += '<ul class="social clearfix mb25" '+adjust+'>';
                if(artist.website) {  output += '<li><a href="'+artist.website+'" title="'+atitle+' Website" target="_blank"><span class="fas fa-globe"></span></a></li>'; }
                if(artist.facebook) {  output += '<li><a href="https://www.facebook.com/'+artist.facebook+'" title="Facebook" target="_blank"><span class="fab fa-facebook"></span></a></li>'; }
                if(artist.twitter) {  output += '<li><a href="https://www.twitter.com/'+artist.twitter+'" title="'+atitle+' Twitter" target="_blank"><span class="fab fa-x-twitter"></span></a></li>'; }
                if(artist.instagram) {  output += '<li><a href="https://instagram.com/'+artist.instagram+'" title="'+atitle+' Instagram" target="_blank"><span class="fab fa-instagram"></span></a></li>'; }
                if(artist.youtube) {  output += '<li><a href="https://www.youtube.com/'+artist.youtube+'" title="'+atitle+' YouTube" target="_blank"><span class="fab fa-youtube"></span></a></li>'; }
                if(artist.soundcloud) {  output += '<li><a href="https://soundcloud.com/'+artist.soundcloud+'" title="'+atitle+' Soundcloud" target="_blank"><span class="fab fa-soundcloud"></span></a></li>'; }
                output += '</ul>';

                el.find('div.socials').html(output);

            });


          $('ul.rea>li').each(function(index){
              var el = $(this);
              setTimeout(function(){
                  el.fadeTo(300,1);
              }, 500 + (index*200));
          });

      })




  }

  if ( !! $('div#recountdown').length ) {
      $('div#recountdown').on('click', function(){
          $('#upp-header.logged-out .signupm>a').trigger('click');
      });
  }
  if ( !! $('div.reloader').length ) {
      setTimeout(function() {
          $('.re-loader').fadeOut(300);
      },2700);
  }

  if ( $('#re-signup').length ){
      $('#contact_email').on('click', function() {
          if ($(this).val() == 'Enter your email...') {
              $(this).data('original', $(this).val()).val('');
          }
      });
      $('#contact_email').on('blur', function() {
          if ($(this).val() == '') {   $(this).val($(this).data('original'));}
      });
  }

  // resistance ibiza
  if ( $('#wrapper-all.rb').length ){
      $('h1.dtitle').addClass('re-title');
      $('h1.dtitle').addClass('fs34');
  }

  //$('.wpml-ls-flag').addClass('grayscale');

}


function resistanceButton() {

    $(document).on('click', '.replay', function(){

        $('#resistanceplay, #re-signup, #recountdown, #rebot').addClass('start');
        $('#header').fadeTo(1200,0);

        setTimeout(function() {   resistanceVideo();  }, 1000 );

    });

    $(document).on('click', '#resistancesignup', function(){

        $('#signup-form').find('.terms').prepend('<input type="hidden" id="allowsubscribe" name="allowsubscribe" value="yes">');

    });


    $('.rescroll').anchorAnimate();
}

function resistanceVideo() {

    var gif = getUrlParam('gif');
    var submitted = getUrlParam('submit');

    if(submitted) {

        $('#seeker').remove();
        $('body').addClass('seekerdone')
        setTimeout(function(){
            $('#resistanceplay.start, #re-signup.start, #recountdown.start, #rebot.start').removeClass('start');
            $('#recountdown.start2').removeClass('start2');
        },500);

        setTimeout(function(){
            $('#header').fadeTo(1200,1);
        },1200);

    } else {

      //$('.re-body').fadeOut(300);
      $('.replay').removeClass('replay');

      $('#seeker').remove();

      var width = $(document).width();
      var height = $(document).height();
      var holder = $('#re-gif');
      var image = 'https://resistancemusic.com/wp-content/uploads/2017/03/resistance-seeker.gif?v='+Math.random().toString(36).substring(2);

      var seekergif = '<img id="seeker" src="'+image+'" width="1100" style="max-width: 100%;">';

      holder.html(seekergif);

      $('#seeker').attr('src', '');
      $('#seeker').attr('src', image);

      $('#seeker').on('load', function(){

          var loadDelay = 3500;

          setTimeout(function() {   $('#resistanceplay.start').removeClass('start');  }, loadDelay+1800 );
          setTimeout(function() {   $('#re-signup.start').removeClass('start');       }, loadDelay+2000 );
          setTimeout(function() {   $('#recountdown.start').removeClass('start');     }, loadDelay+2400 );
          setTimeout(function() {   $('#recountdown.start2').removeClass('start2');   }, loadDelay+2400 );
          setTimeout(function() {   $('#rebot.start').removeClass('start');           }, loadDelay+4000 );
          setTimeout(function() {   $('body').addClass('headerdone');                 }, loadDelay+4500 );
          setTimeout(function() {   $('#header').fadeTo(1200,1);                      }, loadDelay+5500 );
          setTimeout(function() {   $('#newvideo').trigger('click');                           }, loadDelay+7500 );


          setTimeout(function(){ $('body').addClass('seekerdone'); }, 200);
          setTimeout(function(){ $('.re-body').fadeIn(1400);  }, loadDelay+2000);
          setTimeout(function(){ $('.top-particles, .re-logo2').addClass('replay'); }, loadDelay+4000);

      })
  }


/*
    //if(gif == 1) { seekergif = '<img src="https://resistancemusic.com/wp-content/uploads/2017/03/gif1.gif" width="1100" style="max-width: 100%;">'; }


    var seekervid = '\
      <video id="seeker" width="1100" autoplay="true" loop>\
        <source src="https://resistancemusic.com/wp-content/uploads/2017/03/seeker_final_03.mp4" type="video/mp4">\
        <img src="https://resistancemusic.com/wp-content/uploads/2017/03/seeker_final_01.gif" width="1100" style="max-width: 100%;">\
      </video>';




  // CONTROL BREAKPOINT
  if (width <= 111120 && !remobile) {
    holder.html(seekergif);
    log(remobile);
  } else {
    holder.html(seekervid);
    //remobile = false;
    log(remobile);
  }
  */


}


//<h1 class="mb10"><img src="https://resistanceibiza.com/wp-content/uploads/2017/04/resistance-ibiza.png" width="250"></h1>\
//<div class="lbreak clear op50" style="position:relative; margin-bottom:45px !important"></div>\

var artistsmodal = '\
<div id="artistsmodal" class="modal" style="display:none;">\
<div class="md-content">\
<div class="inner ">\
<div class="replacer w880 text-center">\
<div class="info"></div>\
</div>\
</div>\
</div>\
<div class="md-bg"></div>\
<a class="md-next md-nav"><span class="fat fa-chevron-right"></span></a>\
<a class="md-prev md-nav"><span class="fat fa-chevron-left"></span></a>\
<a class="md-close"><i></i><b></b></a>\
</div>';
